export default __webpack_public_path__ + "static/media/remove-trash-bin.24543b3f.svg";